import Vue from 'vue';
import AddOn from './add-on';
import planTable from './plan-table.js';


function Plan(config) {
	if (!(this instanceof Plan)) {
		return new Plan(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

function BillingCycle(config) {
	if (!(this instanceof BillingCycle)) {
		return new BillingCycle(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

BillingCycle.prototype = {
	constructor: BillingCycle,

	amount: 0,
	interval: '',
	amountDue: 0,
	discounted: false,
	description: '',

	applyDiscount: function (coupon) {
		this.discounted = true;
		this.limitedOffer = coupon.limitedOffer;
		this.amountDue = this.amount * ((100 - coupon.discount)/100);
	}
};

BillingCycle.fromDTO = function (id) {
	return function(dto) {
		if (dto === null || dto === undefined) {
			return null;
		}

		return new BillingCycle({
			amount: dto.amount,
			interval: dto.interval,
			displayAmount: dto.amount,
			intervalId: id + '_' + dto.interval,
			hasTrial: dto.hasTrial
		});
	};
};


Plan.prototype = {
	constructor: Plan,

	id: '',
	addOns: null,
	allAddOns: null,
	currentAddOns: null,
	billingCycles: null,
	mappedAddOns: null,
	name: '',
	description: '',
	discounted: false,
	hasQuantity: false,
	quantity: 1,
	prepaidDisplayCode: null,
	expiry: null,
	isInternalFreePlan: false,

	attachAddOns: function (allAddOns) {
		this.allAddOns = allAddOns.map(AddOn.fromDTO);
	},
};

function getName(plan) {
	// change TekScope plan name
	if (plan.id === 'pln_scope_app_base') {
		return 'TekScope PC Waveform Analysis Software';
	}

	return plan.name;
}

function mapBillingCycles(billingCycles, id, isSubCode){
	if (isSubCode) {
		return [{
			intervalId: id + '_' + billingCycles[0].interval,
			displayAmount: 'Prepaid',
			interval: billingCycles[0].interval
		}];
	}

	const list = billingCycles.map(BillingCycle.fromDTO) || [];

	list.map(cycle => {
		// because prepaid and paid will be displayed on different screens we dont need to differeniate interval ids
		cycle.intervalId = id + '_' + cycle.interval;
		cycle.displayAmount = cycle.displayAmount;
		cycle.interval = cycle.interval;
		return cycle;
	});

	return list;
}

function getDescription(id) {
	switch(id) {
	case 'pln_iot_individual':
		return 'For your personal IoT projects / prototyping';
	case 'pln_iot_student':
		return 'For students with a .edu email address';
	case 'pln_iot_enterprise':
		return 'For business IoT applications';
	case 'pln_scope_app_base':
		return '';
	}
}

function getDisplayCode(prepaidCouponId) {
	// create a display code for viewing
	return prepaidCouponId.split('_')[1];
}

function mapAddOns(addOns, selectedAddOns) {
	const list = addOns.map(addOn => {
		addOn.checked = selectedAddOns.includes(addOn.name);
		return addOn;
	});

	return list;
}

function getNameId(name, isSubCode) {
	return name.toLowerCase().replace(/\ /g,'_') + (isSubCode ? '_subcode' : '');
}

function arrayToHash(array) {
	return array.reduce((map, obj) => (map[obj.interval] = obj, map), {});
}

function getExpiryDate(durationInMonths){
	const createdDate = new Date();
	return createdDate.setMonth(createdDate.getMonth() + durationInMonths);
}

Plan.createFromCurrentSubscriptionCode = function (plan, current) {
	let mappedBillingCycles = mapBillingCycles(plan.billingCycles, plan.id, current.prepaidCouponId);

	return new Plan({
		id: plan.id,
		allAddOns: plan.allAddOns,
		currentAddOns: current.plan.currentAddOns,
		mappedAddOns: current.plan.mappedAddOns,
		billingCycles: mappedBillingCycles,
		billingCyclesHash: arrayToHash(mappedBillingCycles),
		name: planTable[plan.id].name,
		description: planTable[plan.id].description,
		prepaidDisplayCode: getDisplayCode(current.prepaidCouponId),
		prepaidCouponId: current.prepaidCouponId,
		expiry: current.expiry
	});
};

Plan.createFromSubscriptionCode = function (plan, coupon) {
	let mappedBillingCycles = mapBillingCycles(plan.billingCycles, plan.id, coupon.id);

	return new Plan({
		id: plan.id,
		allAddOns: plan.allAddOns,
		currentAddOns: coupon.addOns,
		mappedAddOns: plan.allAddOns && mapAddOns(plan.allAddOns, coupon.addOns || []) || [],
		billingCycles: mappedBillingCycles,
		billingCyclesHash: arrayToHash(mappedBillingCycles),
		name: planTable[plan.id].name,
		description: planTable[plan.id].description,
		prepaidDisplayCode: coupon ? getDisplayCode(coupon.id) : null,
		prepaidCouponId: coupon.id,
		expiry: getExpiryDate(coupon.durationInMonths)
	});
};

Plan.fromDTO = function (dto) {
	if (dto === null || dto === undefined) {
		return null;
	}

	let billingCycles = dto && dto.billingCycles.map(BillingCycle.fromDTO(dto.id)) || [];

	return new Plan({
		id: dto.id,
		allAddOns: dto.addOns,
		billingCycles: billingCycles,
		billingCyclesHash: arrayToHash(billingCycles),
		name: planTable[dto.id].name,
		description: planTable[dto.id].description,
		discounted: dto.discounted || false,
		customBilling: dto.customBilling,
		hasQuantity: planTable[dto.id].hasQuantity,
		isInternalFreePlan: dto.isInternalFreePlan,
		quantity: 1
	});
};

export default Plan;



// WEBPACK FOOTER //
// ./src/store/models/plan.js